import React, {
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

type ActivityActionContextValue = {
  submitBusy: boolean;
  cancelBusy: boolean;
  setSubmitBusy: (v: boolean) => void;
  setCancelBusy: (v: boolean) => void;
  blockUI: boolean;
  setBlockUI: (v: boolean) => void;
  blockUIText: string;
  setBlockUIText: (v: string) => void;
};

const ActivityActionContext = createContext<
  ActivityActionContextValue | undefined
>(undefined);

type ProviderProps = {
  children: React.ReactNode;
};

export function ActivityActionProvider({ children }: ProviderProps) {
  const [submitBusy, setSubmitBusy] = useState(false);
  const [cancelBusy, setCancelBusy] = useState(false);
  const [blockUI, setBlockUI] = useState(false);
  const [blockUIText, setBlockUIText] = useState('Memproses… Mohon tunggu.');

  const value = useMemo(
    () => ({
      submitBusy,
      cancelBusy,
      setSubmitBusy,
      setCancelBusy,
      blockUI,
      setBlockUI,
      blockUIText,
      setBlockUIText,
    }),
    [submitBusy, cancelBusy, blockUI, blockUIText]
  );

  return (
    <ActivityActionContext.Provider value={value}>
      {children}
    </ActivityActionContext.Provider>
  );
}

export function useActivityAction() {
  const ctx = useContext(ActivityActionContext);
  if (!ctx) {
    throw new Error(
      'useActivityAction must be used within ActivityActionProvider'
    );
  }
  return ctx;
}
